import React from 'react'
import { Ability, AnyAbility } from '@casl/ability'

export const AbilityContext = React.createContext<AnyAbility>(new Ability())
